import { SearchComponent } from "SuperAdmin/Components";
import { getAllAccounts } from "SuperAdmin/Services/Account";
import { Button, message } from "antd";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./AccountList.module.scss";
import Table from "./Components/Table/Table";
import { handleAPIResponse } from "SuperAdmin/Utils/HandleAPIResponse";
const AccountList = () => {
  const [data, setData] = useState({ isLoading: true, data: [] });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [filters, setFilters] = useState({
    name: "",
    entity_id: null,
    entity_type: null,
  });
  useEffect(() => {
    setData({ ...data, isLoading: true });
    getAllAccounts(
      pagination.page - 1,
      pagination.rowsPerPage,
      filters,
      (res) => {
        handleAPIResponse(res, () => {
          setData({ isLoading: false, data: res.data.data });
          setPagination({
            ...pagination,
            totalRows: res.data.total.total_count,
          });
        });
      }
    );
  }, [
    pagination.page,
    pagination.rowsPerPage,
    filters,
    window.location.pathname,
  ]);
  return (
    <div className={styles["account-list"]}>
      <div className={styles["search-bar"]}>
        <SearchComponent
          placeholder={"Search for user"}
          filters={filters}
          setFilters={setFilters}
          entity={"name"}
        />
        <Link to={"/super-admin/create-account"}>
          <Button type="primary">Create account</Button>
        </Link>
      </div>
      <div className={styles["accounts"]}>
        <Table
          data={data}
          pagination={pagination}
          setPagination={setPagination}
          filters={filters}
          setFilters={setFilters}
        />
      </div>
    </div>
  );
};

export default AccountList;
